import {Controller} from '@hotwired/stimulus';
import {Modal} from 'bootstrap';
import $ from "jquery";
import {useModal} from "../js/stimulus_use/use-modal";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'formContainer',
    ];

    static values = {
        chatId: Number,
        shouldOpen: Boolean,
    };

    connect() {
        useModal(this);

        if (this.shouldOpenValue) {
            this.showContent();
        }
    }

    showContent(event) {
        showPreloader();

        const url = routes['app_messages_rejectcase']
            .replace('__id__', this.chatIdValue)
            .replace('__is_from_account__', event ? true : false);

        $.get(url, response => {
            if (response.status) {
                $(this.formContainerTarget).html(response.result.content);

                this.open();
            } else {
                addAlert('danger', response.message || translations['profile.An unknown error occurred.']);
            }
        }).fail(function () {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        }).always(() => {
            hidePreloader();
        });
    }
}
